const scrollOffset = () => {
    const elements = document.querySelectorAll('[data-scroll-offset]');
    const newOffset = window.innerWidth <= 768 ? '15%' : '20%';

    elements.forEach((element) => {
        if (element.hasAttribute('data-scroll-offset')) {
            if (element.closest('.footer__bottom li')) {
                element.setAttribute('data-scroll-offset', '0%');
            } else {
                element.setAttribute('data-scroll-offset', newOffset);
            }
        }
    });
};

export default scrollOffset;